import { Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function DisplayNoResult({
  chooseNewDate,
  chooseNewVehicle,
  searchText,
}: {
  chooseNewDate?: () => void;
  chooseNewVehicle?: () => void;
  searchText?: string | undefined;
}) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0% 10%',
      }}
    >
      <img
        src="svg/NoSearchResult_ez_transparent.svg"
        alt="not_found"
        style={{ width: '100%', maxHeight: '250px' }}
        data-qa-element-id="no_result_image"
      />

      <Typography variant="subtitle2" textAlign={'center'} gutterBottom data-qa-element-id="no_result_text">
        {searchText
          ? t('targetAttributes.noResultSearchWithText', { searchText })
          : t('refuels.noResult.noResultDateInterval')}
      </Typography>
      {chooseNewDate && chooseNewVehicle && (
        <Stack direction="column" spacing={2} mt={2} sx={{ width: '100%', marginTop: '5svh' }}>
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{
              borderRadius: 4,
              color: 'secondary.main',
              borderColor: 'secondary.main',
            }}
            onClick={chooseNewDate}
            data-qa-element-id="select_new_date_button"
          >
            {t('refuels.noResult.setNewDate')}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            sx={{ borderRadius: 4 }}
            onClick={chooseNewVehicle}
            data-qa-element-id="select_new_target_button"
          >
            {t('refuels.noResult.setNewVehicle')}
          </Button>
        </Stack>
      )}
    </Box>
  );
}
